import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardSubtitle, CardTitle, Col, Row } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'
import NewUnavailableDayForm from './partials/NewUnavailableDayForm'
import UnavailableDaysTable from './partials/UnavailableDaysTable'

import { getUnavailableDays } from './services'
import { handleError } from '../../helpers'

export default function UnavailableDaysList() {
	const [unavailableDays, setUnavailableDays] = useState(null)
	const [filterScope, setFilterScope] = useState('upcoming')

	useEffect(() => {
		!unavailableDays && getUnavailableDays({
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			include: 'user',
			sort: 'date',
		})
			.then(res => setUnavailableDays(res.data.data))
			.catch(error => handleError(error))
	}, [ unavailableDays, filterScope ])

	return (
		<React.Fragment>
			<Row>
				<Col md="4">
					<Card>
						<CardBody>
							<CardTitle>Agregar Día No Disponible</CardTitle>
							<CardSubtitle>Crear nuevo registro</CardSubtitle>
							<hr className='mt-10' />
							<NewUnavailableDayForm 
								reload={() => setUnavailableDays(null)}
							/>
						</CardBody>
					</Card>
				</Col>
				<Col>
					<ListTopBar 
						title="Días No Disponibles"
						subtitle="Listado general de días no disponibles para agendamiento de citas"
						reload={() => setUnavailableDays(null)}
						filterScope={filterScope}
						setFilterScope={setFilterScope}
						scopes={[
							{ label: 'Días Vigentes', value: 'upcoming' },
							{ label: 'Días Vencidos', value: 'expired' },
						]}
						className="mb-10"
					/>
					<Card>
						<CardBody>
							<UnavailableDaysTable 
								unavailableDays={unavailableDays}
								reload={() => setUnavailableDays(null)}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}